import { useState } from 'react'

import AtomFormInput from '@/components/Atoms/AtomFormInput/AtomFormInput'
import AtomSelect from '@/components/Atoms/AtomSelect/AtomSelect'
import HoverElement from '@/components/Atoms/HoverElement/HoverElement'

import { labelWithTooltip } from '../../RequiredLabel/labelWithTooltip'
import {
  type ColumnKey,
  DUPLICATE_COLUMN_MESSAGE,
  getSegmentColumnKey,
} from '../lib/configColumnConflicts'
import type { SegmentColumnsContextValue } from '../UrlExcelTable/SegmentColumnsContext'

const SEGMENT_COLUMN_HINT =
  'Цена из этой колонки уйдёт выбранным сегментам. Для другой колонки введите её номер и выберите сегменты'

type SegmentColumnFieldsProps = {
  segmentColumns: SegmentColumnsContextValue
  conflicts: Set<ColumnKey>
  isOrganisationSelected: boolean
}

function SegmentColumnFields({
  segmentColumns,
  conflicts,
  isOrganisationSelected,
}: SegmentColumnFieldsProps) {
  const { segments, segmentIdsByColumn, onChange } = segmentColumns
  const [column, setColumn] = useState(() => {
    const [firstIndex] = Object.keys(segmentIdsByColumn)
    return firstIndex === undefined ? '' : String(Number(firstIndex) + 1)
  })
  const columnIndex = Number(column) - 1
  const hasColumn = column !== '' && columnIndex >= 0

  return (
    <>
      <AtomFormInput
        layout="stacked"
        idPrefix="config-price-"
        location="stockImportConfig"
        isOrganisationSelected={isOrganisationSelected}
        name="segmentColumnNumber"
        title={labelWithTooltip('Колонка цены сегмента', SEGMENT_COLUMN_HINT)}
        placeholder="A = 1, B = 2, C = 3"
        inputMode="numeric"
        autoComplete="off"
        value={column}
        onChange={(event) => setColumn(event.target.value.replace(/\D/g, ''))}
        error={
          hasColumn && conflicts.has(getSegmentColumnKey(column))
            ? DUPLICATE_COLUMN_MESSAGE
            : ''
        }
      />
      {hasColumn && (
        <HoverElement>
          <AtomSelect
            layout="stacked"
            outlined
            size="large"
            mode="multiple"
            openByHover={false}
            showSearch
            isOrganisationSelected={isOrganisationSelected}
            title={`Сегменты с ценой из колонки ${column}`}
            placeholder="Выберите сегменты"
            options={segments.map((segment) => ({
              value: segment.id,
              label: segment.label,
            }))}
            value={segmentIdsByColumn[columnIndex] ?? []}
            onValuesChange={(segmentIds) => onChange(columnIndex, segmentIds)}
            error=""
          />
        </HoverElement>
      )}
    </>
  )
}

export default SegmentColumnFields
